<template>
  <div :class="stepStatus == 4 && dataDetails.isCommon == 1 ? 'clickNone' : ''">
    <!-- <div class="flex mt-20">
      <div class="flexWidth"><span class="icon"></span></div>
      <div class="flex1">
        <div class="title">{{$t('coll.how_many_people_event')}}</div>
      </div>
    </div> 
    <van-field
        v-model="step_data.live_people"
        :placeholder="$t('global.please_input')"
        class="bgGray mt-10"
      />-->
      <van-row class="bus">
      <div class="color3 font15">{{ $t("coll.will_you_bring_your_child") }}</div>
      <van-radio-group
        v-model="step_data.bring_child"
        class="mt-20"
      >
        <van-radio name="1">
          <span class="color6 font14">{{ $t("coll.yes") }}</span>
        </van-radio>
        <van-radio name="2" class="mt-15"
          ><span class="color6 font14">{{ $t("coll.no") }}</span>
        </van-radio>
      </van-radio-group>
    </van-row>
    <div class="flex mt-20">
      <div class="flexWidth"><span class="icon"></span></div>
      <div class="flex1">
        <div class="title">{{ $t("coll.how_many_parents_are_coming") }}</div>
      </div>
    </div>
    <van-row gutter="20" class="mt-20">
      <van-col span="12">
        <span
          class="ride font14 color3"
          :class="step_data.many_parents == 1 ? 'rideActive' : ''"
          @click="setParent(1)"
          >1</span
        >
      </van-col>
      <van-col span="12">
        <span
          class="ride font14 color3"
          :class="step_data.many_parents == 2 ? 'rideActive' : ''"
          @click="setParent(2)"
          >2</span
        >
      </van-col>
    </van-row>
    <div class="flex mt-20">
      <div class="flexWidth"><span class="icon"></span></div>
      <div class="flex1">
        <div class="title">{{ $t("coll.student_parent_48") }}</div>
        <!-- <div class="color6 font14 pt-5">{{$t('coll.multiple_pictures')}}</div> -->
      </div>
    </div>
    <van-row class="mt-20">
      <van-uploader
        v-model="step_data.files1_url"
        @delete="deleteimg"
        :after-read="afterRead"
        :before-read="beforeRead"
        name="files1"
      />
    </van-row>
    <div class="flex mt-20">
      <div class="flexWidth"><span class="icon"></span></div>
      <div class="flex1">
        <div class="title">{{ $t("coll.parents_code") }}</div>
        <!-- <div class="color6 font14 pt-5">{{$t('coll.multiple_pictures')}}</div> -->
      </div>
    </div>
    <van-row class="mt-20">
      <van-uploader
        v-model="step_data.files2_url"
        @delete="deleteimg"
        :after-read="afterRead"
        :before-read="beforeRead"
        name="files2"
      />
    </van-row>
    
    <div v-if="dataDetails.protocol.length != 0">
      <protocol-sign
        @click="baseImg"
        :busProtocol="dataDetails.protocol"
        :base64="base64"
      ></protocol-sign>
    </div>
    <div class="mt-20">
      <van-button
        v-if="stepStatus == 4 && dataDetails.isCommon == 1"
        disabled
        type="info"
        block
        round
        color="#4d88d2"
        class="saveSub"
        >{{ $t("coll.step_reviewed") }}</van-button
      >
      <a
        href="javascript:;"
        v-else
        @click="submitData()"
        class="saveBtnStep"
        :class="btnDisabled ? 'disabledSubmit' : ''"
        >{{ $t("global.submit") }}</a
      >
    </div>
  </div>
</template>

<script>
import ProtocolSign from "@/components/steps/ProtocolSign";
import Vue from "vue";
import { Toast } from "vant";
import Compressor from "compressorjs";

export default {
  components: {
    "protocol-sign": ProtocolSign,
  },
  props: {
    dataDetails: {
      type: Object,
    },
    status: {
      type: Number,
    },
    disabled: {
      type: Number,
    },
  },
  name: "homeAddress",
  data() {
    return {
      insurance: [],
      stuPhoto: [],
      monPhoto: [],
      vaccination: [],
      stepStatus: "",
      qiniuToken: "",
      type: "",
      base64: "",
      btnDisabled: false,
      sign: "",
      sign_url: "",
      parentNum:'',
      is_child:0
    };
  },
  watch: {
    disabled() {
      this.btnDisabled = false;
    },
  },
  created() {
    this.stepStatus = this.status;
    this.step_data = this.dataDetails.data;
    this.step_data.files1_url = this.tojson(this.dataDetails.data.files1_url);
    this.step_data.files2_url = this.tojson(this.dataDetails.data.files2_url);
    this.qiniuToken = this.dataDetails.qiniuToken;
    if (this.dataDetails.sign_url != "") {
      this.base64 = this.dataDetails.sign_url;
    }
  },
  methods: {
    setParent(flag) {
      this.step_data.many_parents = flag;
    },
    tojson(rows) {
      var ids = [];
      for (var i = 0, len = rows.length; i < len; i++) {
        var signAgainReq = new Object();
        signAgainReq.url = rows[i];
        ids.push(signAgainReq);
      }
      return ids;
    },
    beforeRead(file) {
      return new Promise((resolve) => {
        new Compressor(file, {
          maxWidth: 1200,
          quality: 0.6,
          success: resolve,
          error(err) {
            console.log(err.message);
          },
        });
      });
    },
    afterRead(file, detail) {
      this.type = detail.name;
      if (file.length > 1) {
        for (let i in file) {
          this.upimg(file[i].content);
        }
      } else {
        this.upimg(file.content);
      }
    },
    upimg(data) {
      const that = this;
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: that.$t("pickupcard.uploading"),
      });
      var pic = data.substring(data.indexOf(",") + 1);
      var url = "https://upload-z1.qiniup.com/putb64/-1";
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          var resJson = JSON.parse(xhr.responseText);
          if (resJson.code == 0) {
            that.step_data[that.type].push(resJson.data.key);
            Toast(that.$t("pickupcard.Uploaded"));
          } else {
            Toast(resJson.msg);
          }
        }
      };
      xhr.open("POST", url, true);
      xhr.setRequestHeader("Content-Type", "application/octet-stream");
      xhr.setRequestHeader("Authorization", "UpToken " + that.qiniuToken);
      xhr.send(pic);
    },
    //删除图片
    deleteimg(file, detail) {
      this.step_data[detail.name].splice(detail.index - 1, 1);
    },
    baseImg(data) {
      if (data != "cancel") {
        this.base64 = data;
        this.newSign = true;
      }
    },
    submitData() {
      let that = this;
      if (this.btnDisabled) {
        return;
      }
      // if (that.step_data.live_people==null || that.step_data.live_people=='') {
      //   Toast(that.$t("coll.how_many_people_event"));
      //   return;
      // }
      if (that.step_data.bring_child =='') {
        Toast(that.$t("coll.will_you_bring_your_child"));
        return;
      }
      if (that.step_data.many_parents ==0) {
        Toast(that.$t("coll.how_many_parents_are_coming"));
        return;
      }
      if (that.step_data.files1.length == 0) {
        Toast(that.$t("coll.student_parent_48"));
        return;
      }
      if (that.step_data.files2.length == 0) {
        Toast(that.$t("coll.parents_code"));
        return;
      }
      if (that.dataDetails.protocol.length != 0 && this.base64 == "") {
        Toast(that.$t("coll.please_sign"));
        return;
      }
      this.$nextTick(function () {
        this.btnDisabled = true;
      });
      if (that.dataDetails.protocol.length == 0) {
        that.saveData();
        return;
      }
      if (!that.newSign) {
        that.saveData();
        return;
      }
      var pic = this.base64.substring(this.base64.indexOf(",") + 1);
      var url = "https://upload-z1.qiniup.com/putb64/-1";
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        // toast.clear()
        if (xhr.readyState == 4) {
          var resJson = JSON.parse(xhr.responseText);
          if (resJson.code == 0) {
            Vue.set(that, "sign_url", resJson.data.url);
            Vue.set(that, "sign", resJson.data.key);
            that.saveData();
          } else {
            Toast(resJson.msg);
            that.btnDisabled = false;
          }
        }
      };
      xhr.open("POST", url, true);
      xhr.setRequestHeader("Content-Type", "application/octet-stream");
      xhr.setRequestHeader(
        "Authorization",
        "UpToken " + that.dataDetails.signQiniuToken
      );
      xhr.send(pic);
    },
    saveData() {
      this.btnDisabled = true;
      let data = {
        files4: this.step_data.files4,
        files2: this.step_data.files2,
        files1: this.step_data.files1,
        files3: this.step_data.files3,
        live_people: this.step_data.live_people,
        comment: this.step_data.comment,
        sign: this.sign,
        sign_url: this.sign_url,
        bring_child: this.step_data.bring_child,
        many_parents: this.step_data.many_parents,
      };
      this.$emit("change", data);
    },
  },
};
</script>

<style lang="less" scoped>
</style>